import { useAppTheme } from '@/shared/theme';
import { SxProps, Theme } from '@mui/material';

export function usePaginationTheme() {
  const { theme } = useAppTheme();
  const tokens = theme.pagination;

  const getContainerSx = (): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: tokens.container.gap,
    padding: tokens.container.padding,
  });

  const getButtonSx = (disabled?: boolean): SxProps<Theme> => ({
    minWidth: tokens.button.minWidth,
    height: tokens.button.height,
    padding: tokens.button.padding,
    borderRadius: tokens.button.borderRadius,
    fontSize: tokens.button.fontSize,
    fontWeight: tokens.button.fontWeight,
    bgcolor: disabled ? tokens.button.background.disabled : tokens.button.background.default,
    color: disabled ? tokens.button.text.disabled : tokens.button.text.default,
    border: `1px solid ${disabled ? tokens.button.border.disabled : tokens.button.border.default}`,
    '&:hover': disabled
      ? {}
      : {
          bgcolor: tokens.button.background.hover,
        },
    '&:disabled': {
      bgcolor: tokens.button.background.disabled,
      color: tokens.button.text.disabled,
      borderColor: tokens.button.border.disabled,
      cursor: 'not-allowed',
    },
  });

  const getPageNumberSx = (): SxProps<Theme> => ({
    minWidth: tokens.pageNumber.minWidth,
    height: tokens.pageNumber.height,
    fontSize: tokens.pageNumber.fontSize,
    fontWeight: tokens.pageNumber.fontWeight,
    color: tokens.pageNumber.color,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  });

  const getLabelSx = (): SxProps<Theme> => ({
    fontSize: tokens.label.fontSize,
    fontWeight: tokens.label.fontWeight,
    color: tokens.label.color,
  });

  return {
    tokens,
    getContainerSx,
    getButtonSx,
    getPageNumberSx,
    getLabelSx,
  };
}
